var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"example"},[_c('quill-editor',{ref:"myTextEditor",staticClass:"editor",attrs:{"disabled":false,"value":_vm.content,"options":_vm.editorOption},on:{"change":_vm.onEditorChange,"blur":function($event){return _vm.onEditorBlur($event)},"focus":function($event){return _vm.onEditorFocus($event)},"ready":_vm.onEditorReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }